import { Box, Image } from "@chakra-ui/react";
import { useParams } from "react-router";
import { PageCanvas } from "../../../layouts/PageCanvas";
import { PageContainer } from "../../../layouts/PageContainer";
import { PageHeader } from "../../../layouts/PageHeader";
import useReadRegistry from "../../../services/api/registries/queries/useReadRegistry";
import RegistryContainer from "./RegistryContainer";

const PageRegistry = () => {
  const { registryId } = useParams();

  const { data: dataRegistry, isLoading: isLoadingRegistry } =
    useReadRegistry(registryId);
  // const [isStarred, setIsStarred] = React.useState(false);

  return (
    <PageContainer>
      <PageHeader
        isLoading={isLoadingRegistry}
        back={{ title: "Registries", to: "/app/registries" }}
        title={`${dataRegistry?.title}`}
        isIncludeProfile={true}
        headerElement={
          dataRegistry?.registry_brand_url && (
            <Box h="8" rounded="sm" overflow={"hidden"}>
              <Image
                objectFit={"contain"}
                w="full"
                h="full"
                src={dataRegistry.registry_brand_url}
              ></Image>
            </Box>
          )
          // <ButtonGroup variant={"outline"}>
          //   <IconButton
          //     variant={"ghost"}
          //     onClick={() => setIsStarred(!isStarred)}
          //     aria-label="favorite registry"
          //     icon={
          //       isStarred ? (
          //         <MaterialIcon name="star" fontSize="1.5rem" />
          //       ) : (
          //         <MaterialIcon name="star_outline" fontSize="1.5rem" />
          //       )
          //     }
          //   />
          // </ButtonGroup>
        }
      ></PageHeader>
      <PageCanvas>
        {registryId && (
          <RegistryContainer registryId={registryId}></RegistryContainer>
        )}
      </PageCanvas>
    </PageContainer>
  );
};

export default PageRegistry;
